export default __webpack_public_path__ + "static/media/glasses4.b1256ecd.jpeg";